import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { Button } from '@mui/material'
import { CForm, CFormLabel, CFormTextarea, CRow } from '@coreui/react';
import { useIngredient } from '../contexts/IngredientContext';
import { useAuth } from '../contexts/AuthContext';
import CSelect from './CSelect';
import CInput from './CInput';
import moment from 'moment';

const unitTypes = [
    { value: "kg", label: "kg" },
    { value: "ml", label: "ml" },
    { value: "liter", label: "Liter" },
    { value: "gram", label: "Gram" },
    { value: "piece", label: "Piece" },
]

const AddIngredient = ({ editMode, editIngredientId, setEditIngredientId, setEditMode, ingredientVisible, setIngredientVisible, fetchIngredients }) => {
    const { createIngredient, getSingleIngredient, updateIngredient } = useIngredient()
    const { restaurantId } = useAuth();

    const [validated, setValidated] = useState(false);
    const [ingredientDetails, setIngredientDetails] = useState({
        name: '',
        available_stock: '',
        unit: '',
        description: '',
        expiry_date: '',
        restaurant_id: restaurantId
    });

    useEffect(() => {
        fetchSingleIngredient();
    }, [editIngredientId]);

    const fetchSingleIngredient = async () => {
        if (editIngredientId) {
            const ingredient = await getSingleIngredient(editIngredientId)

            setIngredientDetails({
                ...ingredient
            });
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                if (ingredientVisible && restaurantId) {
                    const ingredient = await createIngredient({ ...ingredientDetails, restaurant_id: restaurantId })
                    if (!ingredient.error) {
                        handleClose();
                        fetchIngredients()
                    }
                } else if (editMode && editIngredientId && restaurantId) {
                    const data = await updateIngredient(editIngredientId, { ...ingredientDetails, restaurant_id: restaurantId });
                    if (!data.error) {
                        handleClose();
                        fetchIngredients()
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleClose = () => {
        setIngredientVisible(false);
        setEditMode(false);
        setEditIngredientId(null);
        setIngredientDetails({
            name: '',
            available_stock: '',
            unit: '',
            description: '',
            expiry_date: '',
            restaurant_id: restaurantId
        });
    };

    return (
        <Dialog draggable={false} header={`${ingredientVisible ? 'Create Ingredient' : 'Edit Ingredient'}`} visible={ingredientVisible || (editMode && editIngredientId !== null)} style={{ width: "29vw" }} onHide={handleClose}>
            <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                <div className='fields-container'>
                    <CRow className="mb-3 mt-3">
                        <CInput
                            label="Name"
                            type="text"
                            className='d-flex'
                            labelClassName='w-50'
                            value={ingredientDetails.name}
                            onChange={(value) => setIngredientDetails({ ...ingredientDetails, name: value })}
                            required={true}
                            errorMessage='Name is required.'
                        />
                    </CRow>
                    {
                        ingredientVisible && (
                            <CRow className="mb-3">
                                <CInput
                                    label="Available Stock"
                                    type="number"
                                    className='d-flex'
                                    labelClassName='w-50'
                                    value={ingredientDetails.available_stock}
                                    onChange={(value) => setIngredientDetails({ ...ingredientDetails, available_stock: value })}
                                    required={true}
                                    errorMessage='Available stock is required.'
                                />
                            </CRow>
                        )
                    }
                    <CRow className="mb-3">
                        <CSelect
                            label="Unit"
                            options={unitTypes}
                            className='d-flex'
                            labelClassName='w-50'
                            value={ingredientDetails.unit}
                            onChange={(value) => setIngredientDetails({ ...ingredientDetails, unit: value })}
                            required={true}
                            errorMessage='Unit is required.'
                        />
                    </CRow>
                    <CRow className="mb-3">
                        <CInput
                            label="Expiry Date"
                            type="date"
                            min={moment().add("1", "days").format("Y-MM-DD")}
                            format="Y-m-d"
                            className='d-flex'
                            labelClassName='w-50'
                            value={ingredientDetails.expiry_date ? moment(ingredientDetails.expiry_date).format("Y-MM-DD") : null}
                            onChange={(value) => setIngredientDetails({ ...ingredientDetails, expiry_date: value })}
                            required={true}
                            errorMessage='Expiry Date is required.'
                        />
                    </CRow>
                    <CRow className="mb-3">
                        <div className="d-flex">
                            <CFormLabel className='w-50 custom-word-break'>Description</CFormLabel>
                            <CFormTextarea
                                rows={3}
                                value={ingredientDetails.description}
                                onChange={(e) => setIngredientDetails({ ...ingredientDetails, description: e.target.value })}
                            />
                        </div>
                    </CRow>
                </div>
                <div className="d-flex button-container p-jc-end justify-content-end">
                    <div className='d-flex'>
                        <Button onClick={() => handleClose()} fullWidth variant="contained" color="inherit" >
                            Cancel
                        </Button>
                        <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                            Submit
                        </Button>
                    </div>
                </div>
            </CForm>
        </Dialog >
    )
}

export default AddIngredient
